import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=66d7292c&scoped=true&"
import script from "./BankAccount.vue?vue&type=script&lang=ts&"
export * from "./BankAccount.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccount.vue?vue&type=style&index=0&id=66d7292c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7292c",
  null
  
)

export default component.exports